module.exports = __webpack_public_path__ + "static/12-1ff71675a6bacbe7ccf1fd7a76d4424d.mp4";